import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateMain } from '@hero/core';
import { useCurrentUser } from '@hero/hooks-shared';
import type { Agreement } from '@hero/schema';
import { DrawerContentList } from '../../../app/Drawer/DrawerContentList';
import { AgreementStatusBadge } from '../Status/AgreementStatusBadge';
import { getAgreementCounterparty } from '../utils';

export interface AgreementSummaryTabProps {
  agreement: Agreement;
}

export function AgreementSummaryTab({ agreement }: AgreementSummaryTabProps) {
  const { t } = useTranslation(['m-agreement']);
  const { orgId } = useCurrentUser();
  const counterparty = getAgreementCounterparty(agreement, orgId);
  const createdAt = agreement.doc?.createdAt;

  return (
    <div className="flex flex-col px-5 py-2">
      <DrawerContentList
        list={[
          {
            label: t('drawer.fields.counterparty'),
            value: counterparty?.name ?? '',
          },
          {
            label: t('drawer.fields.type'),
            value: t(`type.${agreement.type}`, { defaultValue: agreement.type }),
          },
          {
            label: t('drawer.fields.status'),
            value: <AgreementStatusBadge status={agreement.status} />,
          },
          {
            label: t('drawer.fields.currency'),
            value: agreement.currency,
          },
          {
            label: t('drawer.fields.monthly_volume'),
            value: agreement.monthlyVehicleVolume ?? 0,
          },
          {
            label: t('drawer.fields.avg_daily_volume'),
            value: agreement.avgDailyVehicleVolume ?? 0,
          },
          {
            label: t('drawer.fields.starts_at'),
            value: agreement.dates?.start
              ? formatDateMain({ date: agreement.dates.start as never, format: 'date' })
              : '-',
          },
          {
            label: t('drawer.fields.ends_at'),
            value: agreement.dates?.end
              ? formatDateMain({ date: agreement.dates.end as never, format: 'date' })
              : '-',
          },
          {
            label: t('drawer.fields.created_at'),
            value: createdAt
              ? formatDateMain({ date: createdAt as never, format: 'date_time' })
              : '',
          },
        ]}
      />
    </div>
  );
}
